'use client'

import { createContext, ReactNode, useContext, useState } from 'react'
import { IHoverImage } from './types'
import { useWindowSize } from 'react-use'

type AboutPageContextProps = {
    hoverImages: IHoverImage[]
    addHoverImage: (image: IHoverImage) => void
    clearHoverImages: () => void
    windowHeight: number
    windowWidth: number
}

const AboutPageContext = createContext({} as AboutPageContextProps)

type Props = {
    children: ReactNode
}

export const AboutPageContextProvider = ({ children }: Props) => {
    const { width: windowWidth, height: windowHeight } = useWindowSize()
    const [hoverImages, setHoverImages] = useState<IHoverImage[]>([])
    const addHoverImage = (image: IHoverImage) => {
        setHoverImages([...hoverImages, image])
    }
    const clearHoverImages = () => {
        setHoverImages([])
    }

    return (
        <AboutPageContext.Provider
            value={{
                hoverImages,
                addHoverImage,
                clearHoverImages,
                windowWidth,
                windowHeight,
            }}
        >
            {children}
        </AboutPageContext.Provider>
    )
}

export const useAboutPageContext = () => {
    const context = useContext(AboutPageContext)

    if (!context) {
        throw new Error('useAboutPageContext must be used within a AboutPageContextProvider')
    }

    return context
}
